import { useEffect } from "react";
import { useTheme } from "@/utils/themeProvider";

export function useThemeShortcut() {
	const { theme, setTheme } = useTheme();

	useEffect(() => {
		function handleKeyDown(e: KeyboardEvent) {
			// Don't trigger when typing in inputs/textareas/contenteditable
			const target = e.target as HTMLElement;
			if (
				target.tagName === "INPUT" ||
				target.tagName === "TEXTAREA" ||
				target.tagName === "SELECT" ||
				target.isContentEditable
			) {
				return;
			}

			if (e.key === "d" && !e.metaKey && !e.ctrlKey && !e.altKey) {
				setTheme(theme === "dark" ? "light" : "dark");
			}
		}

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [theme, setTheme]);
}
